module.exports = __webpack_public_path__ + "img/generic-signup-header.42dc778b.png";